import React, { useState } from "react";
import instance from "../../instance/AxiosInstance";
import { toast } from "react-toastify";

const PolicyModal = ({ showModal, setShowModal,policy ,userId }) => {
  const [checked, setChecked] = useState(false);

  // if (!visible || !policy) return null;

  const handleCheckboxChange = () => {
    const newValue = !checked;
    setChecked(newValue);
  };



const HandleAgree = async () => {

  console.log(userId, "userId in modal");
  
  if (!checked) {
    toast.warning("⚠️ Please read and agree to the policy before proceeding.");
    return;
  }

  try {
    const response = await instance.put("/api/user/privacy/updatepop_modal", {
      userId,
    });
 setShowModal(false);
    toast.success(" Policy accepted successfully!");
    console.log("Modal hidden response:", response.data);
    return response.data;
  } catch (error) {
    toast.error("❌ Failed to update your preference. Please try again.");
    console.error("Failed to hide modal for user:", error);
    throw error;
  }
};




  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <div
        style={{
          width: "60%", // reduced size
          maxHeight: "80vh",
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          overflowY: "auto",
          position: "relative",
        }}
      >
        <h2 style={{ fontSize: "20px", marginBottom: "12px" }}>{policy.name}</h2>

        {policy.description && (
          <p
            style={{
              color: "#6b7280",
              fontSize: "14px",
              marginBottom: "16px",
            }}
          >
            {policy.description}
          </p>
        )}

        {policy.policy?.map((section, index) => (
          <div key={index} style={{ marginBottom: "16px" }}>
            <h3
              style={{
                fontWeight: "600",
                fontSize: "16px",
                marginBottom: "8px",
              }}
            >
              {section.subtitle}
            </h3>
            {section.subData?.length > 0 ? (
              <ul
                style={{
                  paddingLeft: "20px",
                  listStyleType: "disc",
                  lineHeight: "1.7",
                }}
              >
                {section.subData
                  .filter((line) => line.trim() !== "")
                  .map((line, i) => (
                    <li key={i}>{line}</li>
                  ))}
              </ul>
            ) : (
              <p style={{ color: "#6b7280", marginLeft: "12px" }}>
                No content.
              </p>
            )}
          </div>
        ))}

        <div
          style={{
            marginTop: "24px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <input
            type="checkbox"
            checked={checked}
            onChange={handleCheckboxChange}
            style={{ width: "18px", height: "18px" }}
          />
          <label style={{ fontSize: "14px", color: "#111827" }}>
            I have read and understood the latest policy.
          </label>
        </div>
       <button
       onClick={HandleAgree}

  style={{
    marginTop: "20px",
    padding: "10px 20px",
    backgroundColor: checked ? "#2563eb" : "#a5b4fc", // 💡 darker blue when active, faded blue when disabled
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: checked ? "pointer" : "not-allowed",
    opacity: checked ? 1 : 0.6, // 💡 visual dim when disabled
    transition: "background-color 0.3s, opacity 0.3s",
  }}
  disabled={!checked}
>
  I Agree
</button>


      </div>
    </div>
  );
};

export default PolicyModal;
